import React, { useState, useEffect } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import WeatherSmall from './WeatherSmall';
import { useTranslation } from 'react-i18next';
import VirtualTour360 from './VirtualTour360';
import PhotoGallery from './PhotoGallery';
import VideoPLayer from './VideoPLayer';
import ExperiencePath from './ExperiencePath';
import Reviews from './Reviews';
import Testemonies from './Testemonies';
import { useLocation } from 'react-router-dom';
import PanoramaViewer from './PanoramaViewer';
import castle from '../assets/images/post.jpg'
import {Link} from 'react-router-dom';
import UpiriaModal from './UpiriaModal';  // Adjust the path if needed


const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  width:100%;
  overflow-x: hidden;

  @media (max-width: 768px) {
   text-align:center;
  }
`;

const HeaderContainer = styled.div`
  position: relative;
  height: 70vh;
  width: 100%;
  background-image: ${({ bgImage }) => (bgImage ? `url(${bgImage})` : `loading..`)};
  background-size: cover;
  background-position: center;
  display: flex;
  // align-items: center;
  // justify-content: center;
  color: white;
  // text-align: center;
  padding: 20px;
   align-items: flex-end; /* Adjust to position content at the bottom */
 justify-content: flex-start; /* Adjust to position content at the left */
 
`;

const HeaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4); /* Dark overlay for better text readability */

`;

const Title = styled.h1`
  // position: relative;
  font-size: 2rem;
  font-weight: 600;
  @media (max-width: 768px) {
   font-size: 25px;
    font-weight: 400;
  }
`;


const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 60px auto;
  max-width: 1200px;
  padding: 0 20px;
    width: 100%;
`;

const FirstSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
    width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const WeatherContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`;

const Image = styled.img`
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Details = styled.div`
  flex: 1;
  padding: 20px;
  color: #333;
    max-width: 100%;
`;

const DescriptionTitle = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  color: #385963;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    font-size:25px;
  }
`;

const Description = styled.p`
  font-size: 1rem;
  line-height: 1.8;
  color: #555;
  max-width: 100%;
  @media (max-width: 768px) {
    font-size:12px;
  }
`;

const SecondSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  // margin-top: 50px;
    width: 100%;
`;

const InfoHeader = styled.div`
   z-index: 1;
   margin: 30px 20px;
   display:flex;
   align-items:center;
   justify-content: space-between;
   width: 100%;
  overflow-x: hidden;

   @media (max-width: 768px) {
   flex-direction:column;
   text-align:center;
   justify-content:center;
  }
`;

const HeaderButtons = styled.div`
  display: flex;
  flex-direction:column;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px; /* Space between checkbox and label */
  color: #fff; /* Adjust text color */
`;


const Checkbox = styled.input`
  appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
  position: relative; /* <<< Add this line */

  &:checked {
    background-color: white;
    border-color: white;
  }

  &:checked::before {
    content: '';
    position: absolute;
    left: 5px;
    top: 1px;
    width: 4px;
    height: 10px;
    border: solid #385963;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

const TitlePhoto = styled.div`
  font-size: 40px;
  color: #385963;
  font-weight: 600;
  margin-bottom: 50px;
  text-align: left;


   @media (max-width: 768px) {
    font-size: 25px;
     text-align: center;

  }
`;


const PointsVisitedButton = styled.div``;

const AddToFavoritesButton = styled.div``;

const VirtualTourContainer = styled.div`
  padding: 20px;
  // background: #f9f9f9;
  border-radius: 8px;
  // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
    width: 100%;

  @media (max-width: 768px) {
   padding: 20px;
    border-radius: 8px;
    width: 100%;
    align-items: center;
    display: flex;
    flex-direction:column;
    justify-content: center;
  }
}
`;

const PhotoGalleryContainer = styled(VirtualTourContainer)`
 padding: 20px;
  // background: #f9f9f9;
  border-radius: 8px;
    width: 100%;
  // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  // 
  `;

const ReviewsContainer = styled(VirtualTourContainer)`
 padding: 20px;
  // background: #f9f9f9;
  border-radius: 8px;
  // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  // 
    width: 100%;
`;




const FloatingBookButton = styled.a`
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
  text-decoration: none;
  background: #e55a5c;
  color: #fff;
  text-align: center;
  cursor: pointer;
  border-radius: 0.375rem;
  padding: 1rem 2rem;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.05rem;
  box-shadow: 0 4px 8px rgba(0,0,0,0.3);
  transition: background 0.3s ease;

  &:hover {
    background: #c94b4d;
  }

  // a{
  //  color: white;
  //  text-decoration: none;
  // }
`;



// FilePlaceTypeEnum
const FILE_PLACE_TYPE = {
  Gallery: 0,
  CategoryPhoto: 1,
  CoverPhoto: 2,
  Poster: 3,
};

const DestinationTemplate = () => {

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const { i18n } = useTranslation();
  const [destination, setDestination] = useState({});
  const tokenString = sessionStorage.getItem("token");
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || "en";
  const location = useLocation();
  const { state } = location;
  const [activeComponent, setActiveComponent] = useState(state?.activeComponent || '');
  const [destinationId, setDestinationId] = useState(state?.destinationId || '');
  const [experienceId, setExperienceId] = useState(state?.experienceId || '');
  const [category, setCategory] = useState(state?.category || ''); // Add category to state
  const [visited, setVisited] = useState(false); // State for "Have visited"
  const [favorite, setFavorite] = useState(false); // State for "Add to favorites"
  const loggedIn = sessionStorage.getItem("loggedIn");
  const [showBookingModal, setShowBookingModal] = useState(false);
  const userRole =  sessionStorage.getItem("userRole");
  const [isLoading, setIsLoading] = useState(true);

      useEffect(() => {
  const fetchUserProfile = async () => {
    try {
      const response = await fetch(`${BASE_URL}RegisteredUserProfile/get`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokenString}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch user profile: ${response.status}`);
      }

      const profile = await response.json();

      // Determine ID type and check if it's in visited/favorite arrays
      const idToCheck = category === "destination" ? destinationId : experienceId;

      if (category === "destination") {
        setVisited(profile.destinationsVisited?.includes(idToCheck));
        setFavorite(profile.destinationsFavorites?.includes(idToCheck));
      } else if (category === "experience") {
        setVisited(profile.experiencesVisited?.includes(idToCheck));
        setFavorite(profile.experiencesFavorites?.includes(idToCheck));
      }

    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  if (loggedIn && (destinationId || experienceId)) {
    fetchUserProfile();
  }
}, [loggedIn, destinationId, experienceId, category]);

  
  
     // Initialize form with default structure to avoid undefined errors
      const [form, setForm] = useState({
        name: { gr: '', en: '' },
        description: { gr: '', en: '' },
        location: { latitude: '', longitude: '' },
        link360View: '',
        panoramicView: '',
        categoryId: '',
        coverPhoto: null,
        categoryPhoto: null,
        photos: [],
        existingCoverFileName: null,
        existingCategoryFileName: null,
        // Add existing photos filenames if needed to handle delete on server
        existingGalleryFileNames: [], // optional
      });

  useEffect(() => {
    if (state?.activeComponent) {
      setActiveComponent(state.activeComponent);
    }
    if (state?.destinationId) {
      setDestinationId(state.destinationId);
    }
    if (state?.category) {
      setCategory(state.category);
    }
  }, [state]);

  useEffect(() => {
    if (destination.visited) {
      setVisited(destination.visited);
    }
    if (destination.favorite) {
      setFavorite(destination.favorite);
    }
  }, [destination]);


  useEffect(() => {
    const fetchDestination = async () => {
      try {
        const response = await fetch(`${BASE_URL}Destination/${destinationId}`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setDestination(data);  
        const rawFileNames = data.fileNames; 
        let fetchedFiles = [];
  
        if (rawFileNames.length > 0) {
          const fileResponse = await fetch(`${BASE_URL}Destination/getFiles`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${tokenString}`,
            },
            body: JSON.stringify( rawFileNames),
          });
  
          if (!fileResponse.ok) throw new Error("Failed to fetch file contents");
          fetchedFiles = await fileResponse.json();

        }
  
        // Process fetched files based on their filePlaceType
        const {
          existingCoverFileName,
          existingCategoryFileName,
          existingGalleryFileNames, 
          galleryBase64Srcs,
          coverBase64Src,
          categoryBase64Src,
        } = processFiles(fetchedFiles);
  
        setForm({
          name: data.name || { gr: '', en: '' },
          description: data.description || { gr: '', en: '' },
          location: data.location || { latitude: '', longitude: '' },
          link360View: data.link360View || '',
          panoramicView: data.panoramicView || '',
          categoryId: data.categoryId || '',
          coverPhoto: null,
          categoryPhoto: null,
          photos: [],
          existingCoverFileName,
          existingCategoryFileName,
           existingGalleryFileNames,
          galleryBase64Srcs,
          coverBase64Src,
          categoryBase64Src,
        });



      } catch (error) {
        if (error.message.includes('404')) {
          console.error(`Category ID not found: ${error.message}`);
        } else {
          console.error('Error fetching data:', error);
        }
      }
    };

  const processFiles = (files) => {
  const coverFile = files.find(f => f.filePlaceType === FILE_PLACE_TYPE.CoverPhoto);
  const categoryFile = files.find(f => f.filePlaceType === FILE_PLACE_TYPE.CategoryPhoto);
  const galleryFiles = files.filter(f => f.filePlaceType === FILE_PLACE_TYPE.Gallery);

  const coverBase64Src = coverFile ? `data:${coverFile.mimeType};base64,${coverFile.base64Content}` : null;
  const categoryBase64Src = categoryFile ? `data:${categoryFile.mimeType};base64,${categoryFile.base64Content}` : null;
  const galleryBase64Srcs = galleryFiles.map(f => `data:${f.mimeType};base64,${f.base64Content}`);

  // Collect filenames of gallery files to handle deletions later
  const existingGalleryFileNames = galleryFiles.map(f => f.fileName);


  return {
    existingCoverFileName: coverFile?.fileName || null,
    existingCategoryFileName: categoryFile?.fileName || null,
     existingGalleryFileNames,  
    galleryBase64Srcs,
    coverBase64Src,
    categoryBase64Src,
  };
};


    if (destinationId && category === "destination") {
      fetchDestination();
    }

    const fetchExperience = async () => {
      try {
        const response = await fetch(`${BASE_URL}Experience/${experienceId}`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setDestination(data);
        const rawFileNames = data.fileNames; 
        let fetchedFiles = [];
  
        if (rawFileNames.length > 0) {
          const fileResponse = await fetch(`${BASE_URL}Experience/getFiles`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${tokenString}`,
            },
            body: JSON.stringify( rawFileNames),
          });
  
          if (!fileResponse.ok) throw new Error("Failed to fetch file contents");
          fetchedFiles = await fileResponse.json();
        }
  
        // Process fetched files based on their filePlaceType
        const {
          existingCoverFileName,
          existingCategoryFileName,
          existingGalleryFileNames, 
          galleryBase64Srcs,
          coverBase64Src,
          categoryBase64Src,
        } = processFiles(fetchedFiles);
  
        setForm({
          name: data.name || { gr: '', en: '' },
          description: data.description || { gr: '', en: '' },
          location: data.location || { latitude: '', longitude: '' },
          link360View: data.link360View || '',
          panoramicView: data.panoramicView || '',
          categoryId: data.categoryId || '',
          coverPhoto: null,
          categoryPhoto: null,
          photos: [],
          existingCoverFileName,
          existingCategoryFileName,
           existingGalleryFileNames,
          galleryBase64Srcs,
          coverBase64Src,
          categoryBase64Src,
        });

        
      } catch (error) {
        if (error.message.includes('404')) {
          console.error(`Category ID not found: ${error.message}`);
        } else {
          console.error('Error fetching data:', error);
        }
      }
    };

    if (experienceId && category === "experience") {
      fetchExperience();
    }

  }, [destinationId, experienceId, category]);

  if (!destination.name || !destination.description) {
    return <div>{i18n.t('loading')}</div>;
  }


const handleVisitedChange = async (checked) => {
  try {
    let endpoint = "";

    if (category === "destination") {
      endpoint = checked
        ? `${BASE_URL}RegisteredUserProfile/addDestinationsVisited`
        : `${BASE_URL}RegisteredUserProfile/removeDestinationsVisited`;
    } else if (category === "experience") {
      endpoint = checked
        ? `${BASE_URL}RegisteredUserProfile/addExperiencesVisited`
        : `${BASE_URL}RegisteredUserProfile/removeExperiencesVisited`;
    }

    const response = await fetch(endpoint, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${tokenString}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify([
        category === "destination" ? destinationId : experienceId
      ])
    });

    if (!response.ok) {
      
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    setVisited(checked);
  } catch (error) {
    setVisited(!checked);
    console.error("Error updating visited status:", error);
  }
};


const handleFavoriteChange = async (checked) => {
  try {
    let endpoint = "";

    if (category === "destination") {
      endpoint = checked
        ? `${BASE_URL}RegisteredUserProfile/addDestinationsFavorites`
        : `${BASE_URL}RegisteredUserProfile/removeDestinationsFavorites`;
    } else if (category === "experience") {
      endpoint = checked
        ? `${BASE_URL}RegisteredUserProfile/addExperiencesFavorites`
        : `${BASE_URL}RegisteredUserProfile/removeExperiencesFavorites`;
    }

    const response = await fetch(endpoint, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${tokenString}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify([
        category === "destination" ? destinationId : experienceId
      ])
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    setFavorite(checked);
  } catch (error) {
    setVisited(!checked);
    console.error("Error updating favorite status:", error);
  }
};

  const gpx = true;
  
  return (
    <Container>
      <HeaderContainer  
       bgImage={
         form.coverPhoto
           ? URL.createObjectURL(form.coverPhoto)
           : form.coverBase64Src || 'loading..'
       }>
        <InfoHeader>
        <Title> {destination.name[selectedLanguage]}</Title>
        {loggedIn && userRole==="RegisteredUser" && (<HeaderButtons>
           <CheckboxContainer>
              <Checkbox
                type="checkbox"
                checked={visited}
                onChange={(e) => handleVisitedChange(e.target.checked)}
              />
              <label>{i18n.t('haveVisited')}</label>
            </CheckboxContainer>
            <CheckboxContainer>
              <Checkbox
                type="checkbox"
                checked={favorite}
                onChange={(e) => handleFavoriteChange(e.target.checked)}
              />
              <label>{i18n.t('addToFavorites')}</label>
            </CheckboxContainer>
        </HeaderButtons>)}
        </InfoHeader>
      </HeaderContainer>
      <MainContainer>
        <FirstSection>
          <WeatherSmall destinationWeather={destination.weather} />
          <Details>
            <DescriptionTitle> {destination.name[selectedLanguage]}</DescriptionTitle>
            <Description style={{ whiteSpace: "pre-line" }}>
              {destination.description[selectedLanguage]}
            </Description>
          </Details>
        </FirstSection>
        <SecondSection>
          {destination.videoLink &&
            <VirtualTourContainer>
              <VideoPLayer video={destination.videoLink} />
            </VirtualTourContainer> 
          }
          {destination.link360View &&
            <VirtualTourContainer>
              <VirtualTour360 view360={destination.link360View} />
            </VirtualTourContainer> 
          }
           {destination.gpxPoints && destination.gpxPoints.length > 0 &&
            <PhotoGalleryContainer>
              <ExperiencePath gpxPoints={destination.gpxPoints}/>
            </PhotoGalleryContainer>
          }
          {destination.panoramicView &&
            <PhotoGalleryContainer>
              <PanoramaViewer panorama={destination.panoramicView} />
            </PhotoGalleryContainer>
          }
          {(form.galleryBase64Srcs && form.galleryBase64Srcs.length > 0) &&
            <PhotoGalleryContainer>
              <TitlePhoto>{i18n.t('photos')}</TitlePhoto>
              <PhotoGallery name={destination.name} photos={form.galleryBase64Srcs} />
            </PhotoGalleryContainer>
          }
{/* 
         {destination.upiriaLink && (
           <>
          <FloatingBookButton onClick={() => setShowBookingModal(true)}>
           {i18n.t('bookNow')}
         </FloatingBookButton>
         
         <UpiriaModal
           spaLink={destination.upiriaLink}
           expTitle={destination.name?.en || "Experience"}
           visible={showBookingModal}
           onClose={() => setShowBookingModal(false)}
         />
         </>
         )} */}

         
          {/* <ReviewsContainer>
            <Testemonies />
          </ReviewsContainer> */}
        </SecondSection>
      </MainContainer>
    </Container>
  );
};

export default DestinationTemplate;
